import React from 'react';

import Typography from '@material-ui/core/Typography';
import { Collapse, Theme, WithStyles, createStyles, withStyles, withWidth } from '@material-ui/core';

import { Button } from 'core';
import classNames from 'classnames';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import Tooltip from './Tooltip';

const styles = ({ spacing: { unit }, breakpoints: { up } }: Theme) =>
  createStyles({
    biographyCollapse: {
      fontSize: 14,
      lineHeight: '18px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    biographyCollapseWeb: {
      fontSize: 14,
      lineHeight: '18px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    biographyReadMore: {
      cursor: 'pointer',
    },
    biography: {
      fontSize: 14,
      lineHeight: '18px',
      cursor: 'default',
    },
    root: {
      display: 'flex',
      alignItems: 'center',
    },
    button: {
      minWidth: 'fit-content',
      padding: 2,
      minHeight: 'fit-content',
      alignSelf: 'flex-end',
    },
  });

interface BiographyProviderProps extends WithStyles<typeof styles> {
  provider: any;
  width: string;
}

function BiographyProvider({ provider, classes, width }: BiographyProviderProps) {
  const [open, setOpen] = React.useState(false);
  const [shouldShown, setShouldShown] = React.useState(false);
  const isMobile = /xs|sm/.test(width);
  const handleReadMore = () => {
    setOpen((prevState) => !prevState);
  };
  const lineRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const height = lineRef.current?.offsetHeight ?? 0;
    if (height > 18) {
      setShouldShown(true);
    }
  }, []);

  return isMobile ? (
    <div className={classes.root}>
      <Collapse in={open} collapsedHeight="18px">
        <div ref={lineRef}>
          <Typography
            onClick={handleReadMore}
            id={`biography_${provider.name}`}
            className={classNames(classes.biography, {
              [classes.biographyCollapse]: !open,
              [classes.biographyReadMore]: shouldShown,
            })}
            variant="body1"
          >
            {provider.biography}
          </Typography>
        </div>
      </Collapse>
      {shouldShown && (
        <Button className={classes.button} variant="text" size="small" onClick={handleReadMore}>
          {!open ? <ArrowDropDown /> : <ArrowDropUp />}
        </Button>
      )}
    </div>
  ) : (
    <div className={classes.root} ref={lineRef}>
      {shouldShown ? (
        <Tooltip title={provider.biography}>
          <Typography
            id={`biography_${provider.name}`}
            className={classNames(classes.biography, {
              [classes.biographyCollapseWeb]: shouldShown,
            })}
            variant="body1"
          >
            {provider.biography}
          </Typography>
        </Tooltip>
      ) : (
        <Typography id={`biography_${provider.name}`} className={classes.biography} variant="body1">
          {provider.biography}
        </Typography>
      )}
    </div>
  );
}
export default withWidth()(withStyles(styles)(BiographyProvider));
